/* eslint-disable prefer-template, no-useless-concat, func-names */
import React, {Component} from 'react';
import moment from "moment";
import './SEFTable.scss';

class SEFTable extends Component {

    state = {
        lastUpdated: null,
        table: []
    };

    componentDidMount() {
        const thisState = this;
        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                const xmlDoc = this.responseXML;
                const main = xmlDoc.getElementsByTagName('SEF_EOD');
                let lastUpdated = moment().format('MM-DD-YYYY');
                if (main.length) {
                    lastUpdated = main[0].getAttribute('lastUpdatedTime');
                }


                const items = xmlDoc.getElementsByTagName('SEF_EOD_ITEM');

                const rows = [];
                for (let i = 0; i < items.length; i+=1) {
                    const sefInstrument = items[i].getElementsByTagName('SEF_INSTRUMENT')[0].innerHTML || items[i].getElementsByTagName('SEF_INSTRUMENT')[0].textContent;
                    const sefVol = items[i].getElementsByTagName('SEF_VOL')[0].innerHTML || items[i].getElementsByTagName('SEF_VOL')[0].textContent;
                    const sefBlock = items[i].getElementsByTagName('SEF_BLOCK')[0].innerHTML || items[i].getElementsByTagName('SEF_BLOCK')[0].textContent;
                    const sefOpen = items[i].getElementsByTagName('SEF_OPEN')[0].innerHTML || items[i].getElementsByTagName('SEF_OPEN')[0].textContent;
                    const sefClose = items[i].getElementsByTagName('SEF_CLOSE')[0].innerHTML || items[i].getElementsByTagName('SEF_CLOSE')[0].textContent;
                    const sefSettlement = items[i].getElementsByTagName('SEF_SETTLEMENT')[0].innerHTML || items[i].getElementsByTagName('SEF_SETTLEMENT')[0].textContent;

                    rows.push(
                        <tr key={`seftable_body_row_${i}`}>
                            <td key={`seftable_body_row_${i}_0`} className="sp_value sp_even_row" data-label="Instrument">{sefInstrument}</td>
                            <td key={`seftable_body_row_${i}_1`} className="sp_value sp_odd_row" data-label="Total Volume (USD)">{sefVol}</td>
                            <td key={`seftable_body_row_${i}_2`} className="sp_value sp_even_row" data-label="Block Trade (USD)">{sefBlock}</td>
                            <td key={`seftable_body_row_${i}_3`} className="sp_value sp_odd_row" data-label="Open Level">{sefOpen}</td>
                            <td key={`seftable_body_row_${i}_4`} className="sp_value sp_even_row" data-label="Close Level">{sefClose}</td>
                            <td key={`seftable_body_row_${i}_5`} className="sp_value sp_odd_row" data-label="Settlement Level">{sefSettlement}</td>
                        </tr>
                    );
                }

                thisState.setState({lastUpdated, table: [
                    (<thead key="seftable_head">
                    <tr key="seftable_head_row_0">
                        <th key="seftable_head_row_0_0" className="sp_char"> Instrument </th>
                        <th key="seftable_head_row_0_1" className="sp_value"> Total Volume<br/> USD (&#039;000&#039;) </th>
                        <th key="seftable_head_row_0_2" className="sp_value"> Block Trade<br/> USD (&#039;000&#039;) </th>
                        <th key="seftable_head_row_0_3" className="sp_value"> Open Level </th>
                        <th key="seftable_head_row_0_4" className="sp_value"> Close Level </th>
                        <th key="seftable_head_row_0_5" className="sp_value"> Settlement Level </th>
                    </tr></thead>), (<tbody key="seftable_body">{rows}</tbody>)

                ]});
            }
        };

		const cb = moment().format('YYYYMMDDHHmm');
		const xmlPath = `https://content.marketaxess.com/xml-proxy.php?file=CDS_Trade_Data.xml&cb=${cb}`;


        xhttp.open("GET", xmlPath, true);
        xhttp.send();
    }

    render() {
        if (!this.state.table) return null;

        const lastUpdated = this.state.lastUpdated ? moment(this.state.lastUpdated, 'MM-DD-YYYY') : moment();

        return (
            <div className="table-container">
                <h3>{lastUpdated.format('MMMM Do, YYYY')}</h3>
                <div style={{overflow: 'auto'}}>
                    <table className='xmltable' id='sef_table' cellSpacing='0' border='1'>
                        {this.state.table}
                    </table>
                </div>
            </div>
        );
    }

}

export default SEFTable;



// WEBPACK FOOTER //
// ./frontend/components/Tables/SEFTable/SEFTable.jsx